import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';

import { Text } from '@pinpoint/design-kit';

import { formatNumber, formatPercent } from 'src/functions';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

export function CellDate({ value, ...props }) {
  return (
    <Text
      textWeight="400"
      textSize="small"
      data-tip={value ? dayjs(value).format('HH:mm [GMT]Z (zzz) — ddd, MMM D, YYYY') : null}
      {...props}
    >
      {value ? dayjs(value).format('MMM DD, YYYY') : '-'}
    </Text>
  );
}

CellDate.propTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
};

export function CellPercent({ value, ...TextProps }) {
  return (
    <Text textWeight="400" textSize="small" {...TextProps}>
      {formatPercent(value)}
    </Text>
  );
}

CellPercent.propTypes = {
  value: PropTypes.number.isRequired,
};

export function CellText({ value, ...TextProps }) {
  return (
    <Text textWeight="400" textSize="small" {...TextProps}>
      {value}
    </Text>
  );
}

CellText.propTypes = {
  value: PropTypes.string.isRequired,
};

export function CellNumber({ value, ...TextProps }) {
  return (
    <Text textWeight="400" textSize="small" {...TextProps}>
      {formatNumber(value)}
    </Text>
  );
}

CellNumber.propTypes = {
  value: PropTypes.number.isRequired,
};
